import React, { FC } from 'react'

import Container from '@Components/CMS/Container'
import { TrustPilotWidget } from '@Components/TrustPilotWidget'
import { useSplitTest } from '@Globals/SplitTests/Hooks'

import styles from './Trustpilot.module.scss'

interface TrustPilotProps {
  id?: string
}
const TrustPilot: FC<TrustPilotProps> = ({ id }) => {
  const trustAreaV1 = useSplitTest('trust_area_v1')
  if (trustAreaV1 === 'b') {
    return null
  }

  return (
    <div className={styles.trustpilot} id={id}>
      <Container style={{ marginBottom: 0 }} width="medium">
        <TrustPilotWidget />
      </Container>
    </div>
  )
}

export default TrustPilot
